"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
require("./Collapse.css");
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = require("../button/Button");
var gsap_1 = require("gsap/dist/gsap");
var Icon_1 = require("../icon/Icon");
var string_1 = require("../../utils/string");
var CollapseTheme;
(function (CollapseTheme) {
    CollapseTheme["basic"] = "basic";
    CollapseTheme["button"] = "button";
})(CollapseTheme = exports.CollapseTheme || (exports.CollapseTheme = {}));
var CollapseComp = function (_a) {
    var header = _a.header, _b = _a.headerTag, headerTag = _b === void 0 ? 'h3' : _b, children = _a.children, _c = _a.startExpanded, startExpanded = _c === void 0 ? false : _c, expanded = _a.expanded, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.theme, theme = _e === void 0 ? CollapseTheme.basic : _e, _f = _a.hasIcon, hasIcon = _f === void 0 ? true : _f, onHeaderClick = _a.onHeaderClick, props = __rest(_a, ["header", "headerTag", "children", "startExpanded", "expanded", "disabled", "theme", "hasIcon", "onHeaderClick"]);
    var _g = __read(react_1.useState(expanded !== undefined ? expanded : startExpanded), 2), collapseExpanded = _g[0], setCollapseExpanded = _g[1];
    var _h = __read(react_1.useState(false), 2), expandedComplete = _h[0], setExpandedComplete = _h[1];
    var _j = __read(react_1.useState(expanded !== undefined ? expanded : startExpanded), 2), showContent = _j[0], setShowContent = _j[1];
    var _k = __read(react_1.useState(false), 2), initialTransitionCompleted = _k[0], setInitialTransitionCompleted = _k[1];
    var bodyMask = React.useRef(null);
    var headerId = react_1.useRef(string_1.getRandomString());
    var bodyId = react_1.useRef(string_1.getRandomString());
    var tween = react_1.useRef();
    var HeaderTag = headerTag;
    react_1.useEffect(function () {
        if (expanded !== undefined) {
            setCollapseExpanded(expanded);
            if (expanded)
                setShowContent(true);
        }
    }, [expanded]);
    react_1.useEffect(function () {
        var mask = bodyMask.current;
        if (mask) {
            tween.current = collapseExpanded
                ? gsap_1.gsap.to(mask, {
                    duration: 0.3,
                    height: mask.scrollHeight,
                    ease: 'power2.inOut',
                    onComplete: bodyExpandComplete,
                })
                : gsap_1.gsap.to(mask, {
                    duration: 0.3,
                    height: 0,
                    ease: 'power2.inOut',
                    onComplete: bodyContractComplete,
                });
        }
        if (!collapseExpanded)
            setExpandedComplete(false);
        return function () {
            if (tween.current)
                tween.current.kill();
        };
    }, [collapseExpanded]);
    var bodyContractComplete = react_1.useCallback(function () {
        if (!initialTransitionCompleted)
            setInitialTransitionCompleted(true);
        if (!collapseExpanded)
            setShowContent(false);
    }, [collapseExpanded, initialTransitionCompleted]);
    var bodyExpandComplete = react_1.useCallback(function () {
        var mask = bodyMask.current;
        if (!initialTransitionCompleted)
            setInitialTransitionCompleted(true);
        if (mask && collapseExpanded) {
            mask.removeAttribute('style');
            setExpandedComplete(true);
        }
    }, [collapseExpanded, initialTransitionCompleted]);
    return (React.createElement("div", __assign({}, props, { className: classnames_1.default('Collapse', props.className, "Collapse-" + theme, {
            'Collapse-start': !initialTransitionCompleted,
            'Collapse-expanded': collapseExpanded,
            'Collapse-expandedComplete': expandedComplete,
            'Collapse-disabled': disabled,
        }) }),
        header && (React.createElement(HeaderTag, { id: headerId.current },
            React.createElement(Button_1.Button, { className: "Collapse_header", "aria-expanded": collapseExpanded, "aria-controls": bodyId.current, disabled: disabled, onClick: function (e) {
                    if (expanded === undefined) {
                        setCollapseExpanded(function (prevState) { return !prevState; });
                        if (!collapseExpanded)
                            setShowContent(true);
                        if (onHeaderClick)
                            onHeaderClick(!collapseExpanded, e);
                    }
                    else {
                        if (onHeaderClick)
                            onHeaderClick(collapseExpanded, e);
                    }
                } },
                header,
                hasIcon && (React.createElement(Icon_1.Icon, { className: "Collapse_icon", type: Icon_1.IconType.chevronDown }))))),
        React.createElement("div", { ref: bodyMask, id: bodyId.current, className: "Collapse_bodyMask", "aria-labelledby": headerId.current, "aria-hidden": !collapseExpanded || undefined }, showContent && (React.createElement("div", { "aria-live": collapseExpanded ? 'polite' : 'off', className: "Collapse_body" }, children)))));
};
exports.Collapse = React.memo(CollapseComp);
